import NodePlateHeatExchanger from './node-plate-heat-exchanger';

export default NodePlateHeatExchanger;
